export type CompletePasswordReset = {
    otp: string;
    userEmail: string;
    userPassword: string;
};

export const CompletePasswordResetRequestInit: CompletePasswordReset = {
    otp: "",
    userEmail: "",
    userPassword: "",
};
